import React, { useEffect, useState } from "react";
import {
	getSuppliersAction,
	deleteSupplierAction,
} from "../../../modules/suppliers/Actions";

import {
	suppliersSelector,
	suppliersIsLoadingSelector,
	suppliersCountSelector,
	searchValueSelector,
} from "../../../modules/suppliers/Selectors";

import { connect } from "react-redux";

import List from "../../../components/Lists/List";
import ListItem from "../../../components/Lists/ListItem";
import InfiniteScroll from "react-infinite-scroll-component";
import BusinessType from "./BusinessType";
import getLangData from "../../../utils/getLangData";

const SuppliersList = (props) => {
	const {
		suppliers,
		suppliersIsLoading,
		getSuppliers,
		deleteSupplier,
		searchValue,
		suppliersCount,
	} = props;

	const [size, setSize] = useState(10);
	const [offset, setOffset] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const lang = getLangData().general_words

	useEffect(() => {
		getSuppliers({ size, offset, searchTerm: searchValue });
	}, [getSuppliers, searchValue]);

	const fetchMore = () => {
		// set hasMore to false if the current items are >= the all items in database !
		if (suppliers.length >= suppliersCount) {
			setHasMore(false);
			return false;
		}

		// otherwise get the data from the database
		getSuppliers({ size, offset: suppliers.length, searchTerm: searchValue });
	};

	//
	const dataLength =
		suppliers.length <= suppliersCount ? suppliers.length : suppliersCount;
	return (
		<InfiniteScroll
			dataLength={dataLength}
			hasMore={hasMore}
			next={fetchMore}
			style={{ overflow: "hidden" }}
		>
			<div className="table row block--container my-5">
				<List
					isLoading={suppliersIsLoading}
					header={{
						items: [lang.business_name, lang.busience_type],
						actions: ["Edit", "Delete"],
					}}
					items={suppliers}
				>
					<table className="table">
						<tbody>
							{suppliers.map(({ _id, businessName, businessType }) => {
								return (
									<ListItem
										name="test"
										type={"multi"}
										data={[
											businessName,
											<BusinessType businessType={businessType} />,
										]}
										key={_id}
										editLink={`/suppliers/${_id}`}
										onDelete={() => deleteSupplier(_id)}
									/>
								);
							})}
						</tbody>
					</table>
				</List>
			</div>
		</InfiniteScroll>
	);
};

const mapStateToProps = (state) => ({
	suppliers: suppliersSelector(state),
	suppliersIsLoading: suppliersIsLoadingSelector(state),
	suppliersCount: suppliersCountSelector(state),
	searchValue: searchValueSelector(state),
});

export default connect(mapStateToProps, {
	getSuppliers: getSuppliersAction,
	deleteSupplier: deleteSupplierAction,
})(SuppliersList);
